import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {AlertType} from "../../lib/alert-banner";
import {RequestTemplateService} from "../../services/request-template/request-template.service";

@Component({
  selector: 'app-template-rename-modal',
  templateUrl: './template-rename-modal.component.pug',
  styleUrls: ['./template-rename-modal.component.scss'],
  standalone: false
})
export class TemplateRenameModalComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<string>();
  
  title: string = '';
  subHeading: string = '';
  templateName: string = '';
  placeholderText = $localize `Example name`;
  errors = [
    {name: 'sameName', msg: $localize`A package with this title already exists. `, enabled: false},
    {name: 'validName', msg: $localize`The special characters entered cannot be used.   `, enabled: false},
  ];
  isValid = true;
  invalidTitle = false;
  wrongPattern = false;
  titlePattern = new RegExp(/[^a-zA-Z0-9 _\-():',.\/&]+/);
  @ViewChild('inputElement', { read: ElementRef }) inputElement!: ElementRef;
  turnOffLoader = true;
  templateId = 0;
  savedTeamName = '';
  saveButtonText = 'Save'
  constructor(
    public bsModalRef: BsModalRef,
    private templateService: RequestTemplateService,
  ) {
  }

  ngOnInit(): void {
      this.errors = [...this.errors, {name: 'tooLong', msg: $localize`This field accepts a maximum of 200 characters.`, enabled: false}];
  }


  setError(name: string, enabled: boolean) {
    this.errors.find(o => o.name === name)!.enabled = enabled;
    this.errors = [...this.errors];
    this.isValid = !this.errors.some(error => error.enabled);

  }
  resetErrors(){
    this.isValid = false;
    this.errors.forEach(x => x.enabled = false)
  }

  textValueChanged(event: any) {
    this.isValid = false;
    this.invalidTitle=false;
    let patternMatch = this.titlePattern.test(event);
    this.wrongPattern = patternMatch;
    if(this.errors.some(x => x.enabled)){
      this.resetErrors();
      setTimeout(() => {
        this.inputElement?.nativeElement?.childNodes[0]?.focus();
      }, 0);
    }

  }

  saveButtonClicked(){
    this.resetErrors()

    if(this.templateName.trim() === ''){
      this.setError('validName', true);
    } else if (this.templateName.trim().length > 200) {
      this.setError('tooLong', true);
    }
    else{
      this.turnOffLoader = false;
        this.templateService.renameTemplate(this.templateId, this.templateName.trim()).subscribe({
          next: response => {
            this.turnOffLoader = true;
            this.closeEvent.emit(this.templateName.trim());
            this.bsModalRef?.hide();
          },
          error: response => {
            this.savedTeamName = this.templateName;
            const message: string = response?.error?.message || '';
            if (response.status==400 && message.toLowerCase().includes('already exists')) {
              this.setError('sameName', true)
            }
            this.turnOffLoader = true;
          },    // errorHandler
          complete: () => {
          }, // completeHandler
        });

    }
  }
}

